var LocationPage = (function () {

  // Private methods
  var handleFranchiseFilter = function () {
    var $form = $('[rel="franchise-filter-form"]');
    var $franchiseList = $('[rel="franchise-list"]');
    $form.find('select').on('change', function(e) {
      $franchiseList.html(PetButler.templates.loading({}));
      $form.submit();
    });

    $form.on('submit', function(e) {
      e.preventDefault();
      var $form = $(this);

      $.ajax({
        url: $form.attr('action'),
        type: 'POST',
        dataType: 'json',
        data: $form.serialize(),
        success: function(res) {
          // console.log(res);
          var html = '';
          if (!res.error && res.data.list.length > 0) {
            res.data.list.forEach(function(item) {
              html += PetButler.templates.franchise_location(item);
            });
          }
          else if (!res.error && res.data.list.length == 0) {
            console.log($franchiseList);
            // $franchiseList.forEach(function (item) {
            //   html += PetButler.templates.franchise_location(item);
            // });
          }
          else {
            html = PetButler.templates.not_found({});
          }
          $franchiseList.html(html);
        },
        error: function() {
          $franchiseList.html(PetButler.templates.error({}));
        }
      });
    });
  };

  // Public methods
  return {
    handleFranchiseFilter: handleFranchiseFilter
  };
})();
